import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceShareRcpApiService } from './residence-share-rcp-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceShareRcpApiService extends GeneratedResidenceShareRcpApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
